import { ReduxHelper } from "@al/base-lib";

const request = (async: any, url: string, methods = "post"): any =>
  async((params: any, ctx: any) =>
    ctx.io[methods](url, params, {
      headers: {
        "Content-Type": "application/json",
        "device-id": ctx.deviceId,
      },
    })
  );

export default ReduxHelper.combine({
  // 获取省份列表
  asyncGetProvinces: ({ async }: any) => request(async, "/capi/personal/public/common/address/provinces"),
  // 获取城市列表
  asyncGetCities: ({ async }: any) => request(async, "/capi/personal/public/common/address/cities"),
  // 获取区域 列表
  asyncGetDistricts: ({ async }: any) => request(async, "/capi/personal/public/common/address/districts"),
  // 获取乡镇列表
  asyncGetVillages: ({ async }: any) => request(async, "/capi/personal/public/common/address/villages"),
});
